import './addresscomplete.min.css';
import './addresscomplete.min.js';
var MAP_LEGACY_COUNTRY_NAME_TO_NEW_NAME = {
    'Sint Maarten (Dutch)': 'Sint Maartin (Dutch Part), SX',
    'Bonaire, Sint Eustatius and Saba': 'Dutch Caribbean',
    Turkey: 'Türkiye',
};
var parseFullAddress = function (fullAddress) {
    return {
        address1: fullAddress.Line1,
        address2: fullAddress.Line2,
        zipcode: fullAddress.PostalCode,
        state: fullAddress.ProvinceCode,
        country: MAP_LEGACY_COUNTRY_NAME_TO_NEW_NAME[fullAddress.CountryName] || fullAddress.CountryName,
        city: fullAddress.City,
    };
};
export var setupCanadaPost = function (canadaPostConfig, onAddressChange) {
    // @ts-ignore
    var canadaPostControl = new pca.Address(canadaPostConfig.elements, canadaPostConfig.options);
    if (canadaPostConfig.defaultCountry) {
        canadaPostControl.listen('load', function () {
            canadaPostControl.setCountry(canadaPostConfig.defaultCountry);
        });
    }
    canadaPostControl.listen('populate', function (address) {
        onAddressChange && onAddressChange(parseFullAddress(address));
    });
    canadaPostControl.load();
};
